// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vCwtMa3DHuOi2A_rEygr {\n  background-color: #ffffff;\n  border-radius: 0.21333rem;\n}\n", "",{"version":3,"sources":["webpack://./node_modules/@tencent/dz-bricks-web/es/components/CardSpaceWrapper/index.less"],"names":[],"mappings":"AAEA;EACE,yBAAA;EACA,yBAAA;AADF","sourcesContent":["@import \"@tencent/dz-bricks-ui/styles/index.less\";\n\n.search-card-wrapper {\n  background-color: #ffffff;\n  border-radius: 0.21333rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-card-wrapper": "vCwtMa3DHuOi2A_rEygr"
};
export default ___CSS_LOADER_EXPORT___;
